import React from "react";
import {
  Building2, ShieldCheck, FileText, Zap, TrendingUp, Folder, ReceiptText, File,
} from "lucide-react";

/**
 * QENVA document-type taxonomy (frontend mapping).
 *
 * `key` matches the document.document_type field returned by the backend
 * classifier. Backend KNOWN_TYPES are: lease, insurance, contract, permit,
 * financing, invoice, financials, other.
 *
 * The 8-card grid below mirrors that taxonomy 1:1 — no orphan categories.
 */
export const DOC_CATEGORIES = [
  { key: "all",        icon: Folder,      colorClass: "text-white",                bgClass: "bg-qenva-navy text-white",  ringClass: "ring-qenva-navy" },
  { key: "lease",      icon: Building2,   colorClass: "text-qenva-cat-lease",      bgClass: "bg-qenva-cat-lease/10",     ringClass: "ring-qenva-cat-lease/30" },
  { key: "insurance",  icon: ShieldCheck, colorClass: "text-qenva-cat-insurance",  bgClass: "bg-qenva-cat-insurance/10", ringClass: "ring-qenva-cat-insurance/30" },
  { key: "contract",   icon: FileText,    colorClass: "text-qenva-cat-contract",   bgClass: "bg-qenva-cat-contract/10",  ringClass: "ring-qenva-cat-contract/30" },
  { key: "permit",     icon: ShieldCheck, colorClass: "text-qenva-cat-license",    bgClass: "bg-qenva-cat-license/15",   ringClass: "ring-qenva-cat-license/30" },
  { key: "financing",  icon: Zap,         colorClass: "text-qenva-cat-financing",  bgClass: "bg-qenva-cat-financing/10", ringClass: "ring-qenva-cat-financing/30" },
  { key: "invoice",    icon: ReceiptText, colorClass: "text-qenva-cat-invoice",    bgClass: "bg-qenva-cat-invoice/10",   ringClass: "ring-qenva-cat-invoice/30" },
  { key: "financials", icon: TrendingUp,  colorClass: "text-qenva-cat-financials", bgClass: "bg-qenva-cat-financials/10",ringClass: "ring-qenva-cat-financials/30" },
  { key: "other",      icon: File,        colorClass: "text-zinc-500",             bgClass: "bg-zinc-100",               ringClass: "ring-zinc-300" },
];

const BY_KEY = Object.fromEntries(DOC_CATEGORIES.map((c) => [c.key, c]));

export function getCategoryMeta(docType) {
  return BY_KEY[(docType || "").toLowerCase()] || BY_KEY.contract;
}

/**
 * Tile-shaped icon used in the documents table rows. Filled-pastel style
 * matching the Figma reference. Always renders at the same size — labels
 * outside the tile handle the text.
 */
export default function DocTypeIcon({ docType, size = 36, className = "" }) {
  const meta = getCategoryMeta(docType);
  const Icon = meta.icon;
  const px = size;
  return (
    <div
      className={`rounded-xl grid place-items-center shrink-0 ${meta.bgClass} ${className}`}
      style={{ width: px, height: px }}
      data-testid={`doc-type-icon-${docType || "other"}`}
    >
      <Icon size={Math.round(px * 0.45)} strokeWidth={1.75} className={meta.colorClass} />
    </div>
  );
}
